import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import get from 'lodash/get'

import { AddressBlock } from 'components/sections/common'
import { OfficeGeneralDetails } from 'components/sections/national-offices'
import { Form } from 'components/layout'
import { FloatingBar, Button } from 'components/misc'
import { apiCodeLists, apiOrganizations, apiDownloadFile } from 'helpers/decorators/api'
import { form, meta } from 'helpers/decorators'
import { getBillingAddressFormStatus } from 'helpers/uiPermissions'
import { Input } from 'components/fields'

@meta({
  title: 'My National Office',
  intlKey: 'route.my_national_office'
})
@apiOrganizations({
  myDetail: true,
})
@apiDownloadFile()
@apiCodeLists(['titles', 'phoneTypes'])
@form({
  form: 'national-office-detail',
  initialProps: 'organizations.detail',
})
@connect(({ api }) => ({
  blobs: api.blobs,
}))
class MyNationalOfficeDetail extends Component {
  static propTypes = {
    pristine: PropTypes.bool.isRequired,
    values: PropTypes.object,
    files: PropTypes.object,
    blobs: PropTypes.object.isRequired,
    organizations: PropTypes.object.isRequired,
    submitSucceeded: PropTypes.bool.isRequired,
    submitFailed: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    // codeLists: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    updateMyOrganization: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    onDownloadFile: PropTypes.func.isRequired,
    user: PropTypes.object
  }

  render () {
    const {
      blobs,
      organizations,
      // codeLists,
      handleSubmit,
      updateMyOrganization,
      pristine,
      submitSucceeded,
      submitFailed,
      invalid,
      change,
      values,
      files,
      user,
    } = this.props

    const [isLicenseeFieldVisible, isAddressReadOnly] = getBillingAddressFormStatus(
      user,
      get(organizations, 'detail.hierarchyLevel.value')
    )

    return (
      <Form
        onSubmit={handleSubmit(updateMyOrganization)}
        loading={blobs.loading || organizations.loading}
      >
        <OfficeGeneralDetails
          change={change}
          data={values}
          onDownloadFile={this.props.onDownloadFile}
          files={files}
          displaySettings={false}
          showFinancialData
        />
        <div className="row">
          <div className="col-xs-6">
            <AddressBlock
              intlKey="moduleTitle.billing_address"
              formPrefix="invoiceAddress"
              withCountry
              change={change}
              readOnly={isAddressReadOnly}
              prependFields={
                isLicenseeFieldVisible && (
                  <Input
                    label="Licensee name"
                    intlKey="label.organisation_invoicing_name"
                    name="invoicingName"
                    readonly={isAddressReadOnly}
                  />
                )
              }
              isOrganizationAddress
            />
          </div>
          <div className="col-xs-6">
            <AddressBlock
              intlKey="moduleTitle.shipping_address"
              formPrefix="address"
              copyFrom="invoiceAddress"
              withAction
              withCountry
              data={values}
              change={change}
              isOrganizationAddress
            />
          </div>
        </div>
        <FloatingBar>
          <Button
            intlKey="button.save"
            pristine={pristine}
            submitSucceeded={submitSucceeded}
            submitFailed={submitFailed}
            invalid={invalid}
          >
            Save
          </Button>
        </FloatingBar>
      </Form>
    )
  }
}

export default MyNationalOfficeDetail
